import toast from 'react-hot-toast';
import { useTheme } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import CancelIcon from '@mui/icons-material/Cancel';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { Paper, IconButton, Box, Typography } from '@mui/material';
import WarningIcon from '@mui/icons-material/Warning';
import { useTranslation } from 'react-i18next';

export type BaseToastContainerProps = {
  toastId: string;
  message: string;
  type: 'success' | 'error' | 'warning';
};

export default function BaseToastContainer(props: BaseToastContainerProps): JSX.Element {
  const { palette } = useTheme();
  const isError = props.type === 'error';
  const isWarning = props.type === 'warning';

  const { t } = useTranslation();

  const InititalIcon = isError ? CancelIcon : isWarning ? WarningIcon : CheckCircleIcon;
  const color = palette.mode === 'dark' ? palette.common.white : palette.common.black;

  return (
    <Paper sx={{ ...boxSx, background: `${palette.background.paper} !important`, padding: '10px', borderRadius: '8px' }}>
      <Box sx={boxSx}>
        <InititalIcon sx={{ color: ({ palette }) => (isError ? palette.error.main : isWarning ? palette.warning.main : palette.success.main) }} />
        <Typography component="p">{t(props.message)}</Typography>
      </Box>
      <IconButton onClick={() => toast.dismiss(props.toastId)} children={<CloseIcon sx={{ color: `${color} !important` }} />} />
    </Paper>
  );
}

const boxSx = { display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 1, padding: 0 };
